import { render, staticRenderFns } from "./editBenefit.vue?vue&type=template&id=1a8ef8ce&scoped=true"
import script from "./editBenefit.vue?vue&type=script&lang=js"
export * from "./editBenefit.vue?vue&type=script&lang=js"
import style0 from "./editBenefit.vue?vue&type=style&index=0&id=1a8ef8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ef8ce",
  null
  
)

export default component.exports